import axios from "axios";

const OEF_API_RECORD_BASE_URL = process.env.REACT_APP_API_RECORD_BASE_URL;

/**
 * Instance axios spécifique pour l'API OEF Record.
 * @type {axios.AxiosInstance}
 */
const oefApiRecordInstance = axios.create({
    baseURL: OEF_API_RECORD_BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    },
    timeout: 10000
});

oefApiRecordInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        console.error("Erreur API OEF Record:", {
            message: error.message,
            status: error.response?.status,
            data: error.response?.data
        });
        return Promise.reject(error);
    }
);

/**
 * Login dans oef api record.
 *
 * @param {number} loginId - Identifiant de login.
 * @param {string} password - Mot de passe.
 * @returns {Promise<Object|null>} Réponse de la requête à l'API ou null en cas d'erreur.
 */
export const newLoginOefApiRecord = async (loginId, password) => {
    try {
        const response = await oefApiRecordInstance.post(`/user/new?id=${loginId}&pwd=${password}`);
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la connexion à l'API OEF Record :", error.response?.data?.message || error.message);

        return null;
    }
};

/**
 * Fonction générique pour les requêtes POST vers l'API OEF Record.
 *
 * @param {string} endpoint - Endpoint de l'API (sans baseURL).
 * @param {Object} data - Données à envoyer.
 * @returns {Promise<Object>} Réponse de l'API.
 */
export const postOefApiRecord = async (endpoint, data) => {
    try {
        const response = await oefApiRecordInstance.post(endpoint, data);
        return {
            success: true,
            data: response.data,
            status: response.status
        };
    } catch (error) {
        return {
            success: false,
            error: error.response?.data?.message || error.message,
            status: error.response?.status || 500
        };
    }
};

/**
 * Fonction générique pour les requêtes GET vers l'API OEF Record.
 *
 * @param {string} endpoint - Endpoint de l'API (sans baseURL).
 * @param {Object} params - Paramètres de requête optionnels.
 * @returns {Promise<Object>} Réponse de l'API.
 */
export const getOefApiRecord = async (endpoint, params = {}) => {
    try {
        const response = await oefApiRecordInstance.get(endpoint, { params });
        return {
            success: true,
            data: response.data,
            status: response.status
        };
    } catch (error) {
        return {
            success: false,
            error: error.response?.data?.message || error.message,
            status: error.response?.status || 500
        };
    }
};

export default oefApiRecordInstance;
